
import React, { Component, useEffect, useState } from "react";
import joi from "joi";
import { Modal, Container, Col } from "react-bootstrap";
import { Button } from "react-bootstrap";
// import EquipmentType from './../EquipmentType/EquipmentType';
import swal from "sweetalert";
import validation from "../utill/validation";
import { Collapse, Row, Space } from "antd";
import axios from "axios";
import api from "../config.json";
import Table from "../Common/table";
import dateTime from "../utill/dateTime";
import { useHistory } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faEdit,
  faTrash,
  faEye,
  faPlus,
  faFileImport,
  faDownload,
  faCircle,
} from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";
import Excelimport from "../utill/Excelimport";
import Loading from "../utill/LoadingComponent";
import { Select as AntdSelect } from "antd";
import { QRCodeSVG } from "qrcode.react";
import XLSX from "xlsx";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import moment from "moment";
import _ from "lodash";
import Operation from "antd/lib/transfer/operation";
import { Content } from "antd/es/layout/layout";

const Kneading_GreenSheet = ({ RightName, getRightsForAccess, Heading }) => {
  const [sortColumn, setSortColumn] = useState({
    path: "PartID",
    order: "asc",
  });
  const history = useHistory();
  const [size, setSize] = useState("lg");
  const [opStatus, setopStatus] = useState("");
  const [Inputdata, setInputData] = useState({});
  const [modelState, setmodelState] = useState(false);
  const [modelState1, setmodelState1] = useState(false);

  const [Update, setUpdate] = useState({});
  const [loader, setLoader] = useState(false);
  const [templateList, setTemplateList] = useState([]);
  const [VendorList, setVendorList] = useState([]);
  
  const [RMStorageList, setRMStorageList] = useState([]);

  const [selectedTemplate, setSelectedTemplate] = useState({ Columns: [] });

  const [rows, setRows] = useState([]);
  const [errors1, setErrors1] = useState({});
  const [errors, seterrors] = useState({});
  const [ImageList, setImageList] = useState([]);
  const [QRCodeVisible, setQRCodeVisible] = useState(false);
  const [RMlist, setRMlist] = useState([]);
  const [PdfData, setPdfData] = useState([]);
  const [QRCodeArray, SetQRCodeArray] = useState([]);
  const [EnableAllPdf, SetEnableAllPdf] = useState(false);
  const [AdjustedQty, setAdjustedQty] = useState([]);
  const [MoldMaster, setMoldMaster] = useState([]);

  const [RMIdList, setRMIdList] = useState([]);
  const [UnitOfMeasurment, setUnitOfMeasurment] = useState("");
  const [inputData, setinputData] = useState({PrintType:false,From:new Date(),Till:new Date()});

  const [Type, setType] = useState("");
  const [Quantity, setQuantity] = useState("");

  const [BatchCode, setBatchCode] = useState("");

  const [Remarks, setRemarks] = useState("");
  const [RawMaterialData, setRawMaterialData] = useState([]);

  const [ChekpointId, setChekpointId] = useState("");
  const [NumOfPackings, setNumOfPackings] = useState(1);
  // const [Date, setDate] = useState([]);
  const [spareList, setspareList] = useState([]);
  const { Panel } = Collapse;
  function callback(key) {
    console.log(key);
  }
  console.log(PdfData, "vhfvhdfvbhbvd");
  const handelOnPDfEnable = (e, input) => {
    let data = [...RawMaterialData];

    if (e.currentTarget.checked) {
      // Enable the PDF and add it to the list if not already present
      const exists = data.some((item) => item._id === input._id);

      if (!exists) {
        const updatedInput = { ...input, Enable: true }; // Avoid mutating input
        data.push(updatedInput);
      } else {
        data = data.map((item) =>
          item._id === input._id ? { ...item, Enable: true } : item
        );
      }

      SetEnableAllPdf(true); // Set "EnableAllPdf" to true
    }
    if (!e.currentTarget.checked) {
      data = data.map((item) => {
        console.log("jhveffj", item._id === input._id, item, input);
        return item._id === input._id ? { ...item, Enable: false } : item;
      });
    }
    setRawMaterialData(data);
    console.log(e.currentTarget.checked, "sdhbsdfusd", data);
    setPdfData(data);
  };
  const handelSelectAll = (e) => {
    const isChecked = e.currentTarget.checked;

    // Update the componentList with updated 'Enable' values
    const updatedList = RawMaterialData.map((one) => ({
      ...one,
      Enable: isChecked,
    }));

    // Update state
    setRawMaterialData(updatedList);
    setPdfData(updatedList);
    SetEnableAllPdf(isChecked);
  };

  const columns = [
    {
      key: "select",
      label: <input type="checkbox" onChange={handelSelectAll} />,
      content: (obj) => (
        <input
          type="checkbox"
          checked={obj["Enable"]}
          onChange={(e) => handelOnPDfEnable(e, obj)}
        />
      ),
    },
    { path: "KneaderAt", label: "Date / Time",
        content: (obj) => (
          <label>{obj.KneaderAt && moment(obj.KneaderAt).format("DD-MM-YY / hh:mm a")}</label>
        ), },
    { path: "Kneader_ID", label: "Asset Name" },
    { path: "BatchCode", label: "Batch Code" },
    {
      path: "CompoundCode",
      label: "Compound Code"
    },
    { path: "UniqueID", label: "QR Unique ID" },
    { path: "TotalGreenSheetsQtyProduced", label: "Produced Qty (kg)" },
    { path: "GreenSheetAvailable", label: "Available Qty (kg)" },
  
    { path: "KneaderPrinted", label: "Printed Status",     content: (obj) => <label>{`${((obj.KneaderPrinted == true ? 'Yes':'No') )?? 'No'}`}</label>,}



    // { path: "ProcessState", label: "State" },


    
    // {
    //   path: "createdAt",
    //   label: "Created Date",
    //   content: (obj) => (
    //     <React.Fragment>
    //       <label>{dateTime.getStringOfDateTime(obj.createdAt)}</label>
    //     </React.Fragment>
    //   ),
    // },
    // {
    //   path: "updatedAt",
    //   label: "Last Updated Date",
    //   content: (obj) => (
    //     <React.Fragment>
    //       <label>{dateTime.getStringOfDateTime(obj.updatedAt)}</label>
    //     </React.Fragment>
    //   ),
    // },
    // {
    //   key: "view",
    //   content: (user) => (
    //     <button
    //       disabled={
    //         !getRightsForAccess("DynamicDataRights", RightName, "update")
    //       }
    //       onClick={() => {
    //         console.log(user, "View clicked");
    //         setUpdate(user);
    //         setopStatus("view");
    //         const UnitOfMeasurement = _.find(templateList, {
    //           RM_ID: user.RM_ID,
    //         });
    //         if (UnitOfMeasurement) {
    //         }
    //         if (UnitOfMeasurement?.UnitOfMeasurement) {
    //           setUnitOfMeasurment(UnitOfMeasurement.UnitOfMeasurement);
    //         } else {
    //           console.warn(
    //             "UnitOfMeasurement is not available in filteredMeasurmentUnit."
    //           );
    //         }
    //       }}
    //       className="btn btn-sm btn-primary"
    //     >
    //       <FontAwesomeIcon icon={faEye} />
    //     </button>
    //   ),
    // },
    // {
    //   key: "update",
    //   content: (user) => (
    //     <button
    //       disabled={
    //         !getRightsForAccess("DynamicDataRights", RightName, "update")
    //       }
    //       onClick={() => {
    //         console.log(user, "Edit clicked");
    //         setUpdate(user);
    //         setopStatus("update");
    //       }}
    //       className="btn btn-sm btn-primary"
    //     >
    //       <FontAwesomeIcon icon={faEdit} />
    //     </button>
    //   ),
    // },
  ];

  useEffect(() => {
    if (opStatus == "view" || opStatus == "update") {
      setRows(Update.checkpoints);
      setQRCodeVisible(true);
      setInputData(Update);
      setmodelState(true);
    } else {
      setRows([]);
    }
  }, [opStatus]);

  console.log(Update, "wkhfwehkf");
  useEffect(() => {
  
    Heading("Green Sheet (QR)");
    getRMTypeMaster();
    getVendorMaster();
    getRMStorageMaster();
    RawMatreialMaster();
  }, []);
  const getVendorMaster = () => {
    axios
      .get(api.api + "vendor")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.Vendor,
          value: one.Vendor,
        }));
        setVendorList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const getRMStorageMaster = () => {
    axios
      .get(api.api + "rmStorageWater")
      .then((result) => {
        const list = result.data.map((one) => ({
          Name: one.StorageLocation,
          value: one.StorageLocation,
        }));
        setRMStorageList(list);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const getRMTypeMaster = () => {
    axios
      .get(api.api + "RMMaster")
      .then((result) => {
        
const data =_.uniqBy(result.data, "RM_Type")
const list = data.map((one) => ({
  Name: one.RM_Type,
  value: one.RM_Type
  
}))
setTemplateList(list);
setRMlist(data)
      })
      .catch((err) => {
        console.log(err);
      });
  };


  const RawMatreialMaster = () => {
    axios
    .patch(api.api + "kneading",inputData)
      .then((result) => {
        if(result.data.length > 0) {
          const sortedData = [...result.data].sort((a, b) =>
            b.updatedAt.localeCompare(a.updatedAt)
          );
      
          // Update the state with sorted data
          setRawMaterialData(sortedData);
        }else{
          swal('No data available')
          setRawMaterialData([]);

        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  
  const downloadPDF = async (qrCodeGroups, Inputdata) => {
    console.log(qrCodeGroups, Inputdata, "currect dowload function dta");
    const pdf = new jsPDF("p", "mm", "b5");
    for (let i = 0; i < qrCodeGroups.length; i++) {
      const page = document.getElementsByClassName("a4-page")[i];
      const canvas = await html2canvas(page);
      const imgData = canvas.toDataURL("image/png");
      const imgProps = pdf.getImageProperties(imgData);
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
      if (i < qrCodeGroups.length - 1) pdf.addPage();
    }
    pdf.save(
      `GreenSheet.pdf`
    );

    if (opStatus !== "view") {
      handleCloseModel();
    }
  };

  const A4Sheet = (QRCodeVisible, Inputdata) => {
    // Split the QR codes into groups of 4
    const qrCodeGroups = [];
    const stickersPerPage = 16; // 4x4 grid on each page
    if (QRCodeVisible) {
      const totalStickers = Number(NumOfPackings);
      // const stickersPerPage = 9; // 3x3 grid on each page
      for (let i = 0; i < totalStickers; i += stickersPerPage) {
        qrCodeGroups.push(
          [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
            (_, j) => i + j
          )
        );
      }
    }

    // Prepare the QR Code value to display in each QRCodeSVG
    const QrCode = `CC : ${Inputdata.RM_Type};BN : ${
      Inputdata.InvoiceNo
    };TC : ${Inputdata.TestReportNo};MD : ${moment(
      Inputdata.InvoiceDate
    ).format("DD-MM-YY")};ED : ${moment(Inputdata.ExpiryDate).format(
      "DD-MM-YY"
    )};QT : ${Inputdata.Qty}`;

    return (
      <div>
        {opStatus === "view" && (
          <Button
            type="primary"
            onClick={() => downloadPDF(qrCodeGroups, Inputdata)}
            style={{ marginBottom: "16px" }}
          >
            Download as PDF
          </Button>
        )}

        <div className="a4-sheet-scrollable">
          {qrCodeGroups.map((group, pageIndex) => (
            <div
              className="a4-page"
              key={pageIndex}
              style={{ pageBreakAfter: "always" }}
            >
              <div
                                         style={{
                                           display: "grid",
                                           gridTemplateColumns: `repeat(${Math.sqrt(
                                             16
                                           )}, 1fr)`, // 3 columns in each row
                                           gridTemplateRows: `repeat(${Math.sqrt(
                                             16
                                           )}, auto)`, // 3 rows per page (auto height)
                                           gap: "57px", // Optional: Adjust the gap between items as needed
                                           justifyItems: "center",
                                           alignItems: "center",
                                         }}
                                       >
                                         {group.map((one, index) => (
                                           <div
                                             className="d-flex flex-column justify-content-center align-items-center "
                                             key={index}
                                             style={{ textAlign: "center",marginBottom:'10px'}}
                                           >
                                             <QRCodeSVG
                                               value={one.QrCode}
                                               level={'M'}
                                               size={80}
                                               style={{marginBottom:'3px'}}
                                             />{" "}
                    {/* Adjust the size of the QR code */}
                    <p
                       style={{
                        fontSize: "9px",
                        color: "black",
                        letterSpacing: "0.5px",
                        lineHeight: "1.2",
                      }}
                      className="bolder p-0 m-0"
                    >
                      {Inputdata.RM_Type}
                      <br />
                      {Inputdata.InvoiceNo}
                      <br />

                      {`${index + 1} / ${NumOfPackings}`}

                    </p>
                   
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };
  const handleSort = (sortColumn) => {
    if (RawMaterialData.length > 0) {
      const sorted = _.orderBy(
        RawMaterialData,
        [sortColumn.path],
        [sortColumn.order]
      );
      setSortColumn(sortColumn);

      setRawMaterialData(sorted);
    }
  };
  const handleCloseModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleHideModel = () => {
    setopStatus("");
    setmodelState(false);
  };
  const handleCloseModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const handleHideModel1 = () => {
    setopStatus("");
    setmodelState1(false);
  };
  const schema = {
    InvoiceNo: joi.string().required(),
    RM_Type: joi.string().required(),
    TestReportNo: joi.string().required(),
    InvoiceDate: joi.string().required(),
    ExpiryDate: joi.string().required(),
    Qty: joi.number().required(),
    NumOfPackings: joi.number().required(),
    _id: joi.string(),
  };

  const handleOnChange = ( name, value) => {
 

    setinputData((prev) => ({
    ...prev,
    [name]: value,
  }));

  };

  const downloadExcel = () => {
    // Create a new workbook
    const workbook = XLSX.utils.book_new();

    // Prepare data with headers only
    const headers = getColumnsWithoutUserInput(selectedTemplate.Columns).map(
      (column) => column.DbFieldName
    );
    headers.unshift("StandardType");
    const worksheetData = [headers];

    // Create a worksheet
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

    // Append the worksheet to the workbook
    XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");

    // Generate and download the Excel file
    XLSX.writeFile(workbook, `${selectedTemplate.Name}_template.xlsx`);
  };

  const getColumnsWithoutUserInput = (allColumns = []) => {
    const columns = [...allColumns];
    return columns.filter((x) => !x.DataType.startsWith("UserInput"));
  };

  const handleFileUpload = (e) => {
    const fileInputElement = document.createElement("input");
    fileInputElement.type = "file";
    fileInputElement.accept = ".xlsx, .xls";
    fileInputElement.multiple = false;

    // Handle the file upload when the user selects a file
    fileInputElement.addEventListener("change", (event) => {
      const file = event.target.files[0];
      const reader = new FileReader();

      reader.onload = (e) => {
        const binaryStr = e.target.result;
        const workbook = XLSX.read(binaryStr, { type: "binary" });
        const firstSheetName = workbook.SheetNames[0];
        const worksheet = workbook.Sheets[firstSheetName];
        const jsonData = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        const headers = jsonData[0];
        const rows = jsonData.slice(1);
        const formattedData = rows.map((row) => {
          let obj = {};
          row.forEach((cell, index) => {
            obj[headers[index]] = cell;
          });
          return obj;
        });
        setRows(formattedData);
        // Clean up: remove the file input element from the DOM
        fileInputElement.remove();
      };

      // Read the file as a binary string
      reader.readAsBinaryString(file);
    });

    // Programmatically trigger the file input click
    fileInputElement.click();
  };

  const onDelete = (data) => {
    swal({
      title: "Are you sure?",
      text: "Once deleted, you will not be able to recover this",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((willDelete) => {
      if (willDelete) {
        axios
          .delete(api.api + "compoundCode/" + data._id, { data: data })
          .then((result) => {
            toast.success(`Deleted  Successfully`, {
              position: "bottom-right",
              autoClose: 2000,
              hideProgressBar: false,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              style: {
                background: "green", // Set your desired background color
                color: "white", // Set your desired text color
              },
            });
          })
          .catch((err) => {
            if (err.response && err.response.data) {
              swal(`${err.response.data.message}`);
            } else {
              swal(`${err}`);
            }
            // toast.success(`${err}`, {
            //   position: 'bottom-right',
            //   autoClose: 2000,
            //   hideProgressBar: false,
            //   closeOnClick: true,
            //   pauseOnHover: true,
            //   draggable: true,
            //   progress: undefined,
            //   style: {
            //     background: 'red', // Set your desired background color
            //     color: 'white',     // Set your desired text color
            //   },
            // });
          });
      } else {
        // this.setState({ querySuccess: false });
        // swal("Your imaginary file is safe!");
      }
    });
  };
  const handleGetData= (value)=>{

    axios
      .patch(api.api + "kneading",inputData)
      .then((result) => {
        if(result.data.length > 0) {

          setRawMaterialData(result.data);
        }else{
          swal('No data available')
          setRawMaterialData([]);

        }
      })
      .catch((err) => {
        console.log(err);
      });

  }
  const validateCheckCheckPoints = (rows = []) => {
    let errorObj = { IsError: false, message: [] };
    for (let i = 0; i < rows.length; i++) {
      if (rows[i].StandardType == "Dimension") {
        const dimensionField = selectedTemplate.Columns.find(
          (x) => x.DataType == "StandardDimension"
        );
        if (dimensionField && !rows[i][dimensionField.DbFieldName]) {
          errorObj.IsError = true;
          errorObj.message.push(
            `Row Number ${i + 1} ${
              dimensionField.FieldName
            } is mandatory for Dimension Type check point.`
          );
          break;
        }
      }
    }
    return errorObj;
  };

  const handelSaveData = (data, AdjustedQty) => {
    console.log(data, "cvosjnvjnv", AdjustedQty);
    const checksheet = { ...AdjustedQty[0] };
    // delete checksheet.__v
    // delete checksheet.createdAt
    // delete checksheet.updatedAt
    // const errors = validation.validate(checksheet, schema);
    // if (errors) {
    //   seterrors(errors);
    //   return;
    // }
    checksheet["UniqueID"] = data.UniqueID;
    setLoader(true);
    if (opStatus == "update") {
      axios
        .post(api.api + "adjustInventory", checksheet)
        .then((result) => {
          swal("Data Update Successfully");
          // setQRCodeVisible(true);
          RawMatreialMaster();
          handleCloseModel();
          setAdjustedQty([]);
          setLoader(false);
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    } else {
      axios
        .post(api.api + "RMDataEntry", Inputdata)
        .then((result) => {
          console.log(result, "cdisivbi");
          swal("Data Saved Successfully");
          // Split the QR codes into groups of 4
          setQRCodeVisible(true);
          const qrCodeGroups = [];
          const stickersPerPage = 16; // 4x4 grid on each page
          // if (QRCodeVisible) {
          const totalStickers = Number(NumOfPackings);
          // const stickersPerPage = 9; // 3x3 grid on each page
          for (let i = 0; i < totalStickers; i += stickersPerPage) {
            qrCodeGroups.push(
              [...Array(Math.min(stickersPerPage, totalStickers - i))].map(
                (_, j) => i + j
              )
            );
          }
          // }
          if (qrCodeGroups.length > 0) {
            downloadPDF(qrCodeGroups, Inputdata);
          }
          // if(Result){
            handleCloseModel()
          // }
          RawMatreialMaster();
          setLoader(false);
          seterrors({});
        })
        .catch((err) => {
          if (err.response && err.response.data) {
            swal(err.response.data.message, { dangerMode: true });
          }
          console.log(err);
          setLoader(false);
        });
    }
  };
  const downloadPDFforAll = (data) => {
    console.log(data,"frffghb");
    const pdf = [];

    data.map(
      (one) =>
        one.Enable &&
        [...Array(Math.min(NumOfPackings))].forEach((_, j) => {
          pdf.push({
            
             QrCode : JSON.stringify({
              CompoundCode: one.CompoundCode,
              Kneader: one.Kneader_ID,
              StorageLocation: one.GreenSheetStorageLocation,
              TotalQty: one.Qty,
              DateTime: moment(one.createdAt).format("DD-MM-YY"),
              UID: one.UniqueID,
              Qty: one.Qty,

            }),
            
            index: j,
            UniqueID: one.UniqueID,
            CompoundCode: one.CompoundCode,
            batchCode: one.BatchCode,
            Location: one.GreenSheetStorageLocation,
            NumOfPackings: 1,
          });
        })
    );
    const qrCodeGroups = [];
    const stickersPerPage = 20; // 4x4 grid on each page
    // if (QRCodeVisible) {
    const totalStickers = Number(pdf.length);
    // const stickersPerPage = 9; // 3x3 grid on each page
    for (let i = 0; i < pdf.length; i += stickersPerPage) {
      qrCodeGroups.push(pdf.slice(i, i + stickersPerPage));
    }

    // }
    console.log("downloadPDF", data, pdf, qrCodeGroups);
    setmodelState1(true);
    SetQRCodeArray(qrCodeGroups);
  };



  return (
    <>
      {/* <div className='text-center'>
       
        <p>Checksheet Master</p>
      </div> */}
      {loader ? <Loading /> : <></>}

  
   <Modal
        backdrop={"static"}
        className=""
        size={size}
        show={modelState1}
        onHide={handleHideModel1}
      >
        <Modal.Header closeButton>
          <Modal.Title className="text-center"> Green Sheet (QR)</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {/* <div className="collapse" data-parent="#parent" id={`Inputdata${id}`}> */}

          {console.log(NumOfPackings, "snsdonsdn")}
          <div className="a4-sheet">
            {
              QRCodeArray && QRCodeArray.length > 0 && (
                <div>
                  <Button
                    type="primary"
                    onClick={() => downloadPDF(QRCodeArray, Inputdata)}
                    style={{ marginBottom: "16px" }}
                  >
                    Download as PDF
                  </Button>
               <div style={{overflowY:'scroll',height:'72vh'}} className="">
                  {QRCodeArray.map((group, index) => (
                    <div className="a4-sheet-scrollable">
                      <div
                        className="a4-page"
                        // key={pageIndex}
                        style={{ pageBreakAfter: "always" }}
                      >
                        <div
                                                   style={{
                                                     display: "grid",
                                                     gridTemplateColumns: `repeat(${Math.sqrt(
                                                       16
                                                     )}, 1fr)`, // 3 columns in each row
                                                     gridTemplateRows: `repeat(${Math.sqrt(
                                                       16
                                                     )}, auto)`, // 3 rows per page (auto height)
                                                     gap: "57px", // Optional: Adjust the gap between items as needed
                                                     justifyItems: "center",
                                                     alignItems: "center",
                                                   }}
                                                 >
                                                   {group.map((one, index) => (
                                                     <div
                                                       className="d-flex flex-column justify-content-center align-items-center "
                                                       key={index}
                                                       style={{ textAlign: "center",marginBottom:'10px'}}
                                                     >
                                                       <QRCodeSVG
                                                         value={one.QrCode}
                                                         level={'M'}
                                                         size={80}
                                                         style={{marginBottom:'3px'}}
                                                       />{" "}
                              {/* Adjust the size of the QR code */}
                              
                              <p
                                 style={{
                                  fontSize: "9px",
                                  color: "black",
                                  letterSpacing: "0.5px",
                                  lineHeight: "1.2",
                                }}
                                className="bolder p-0 m-0"
                              >
                                {one.UniqueID} 
                                <br />

                                {one.batchCode} / {one.CompoundCode}
                                <br />

                                {one.Location}
                                <br />

                                {/* {`${1 + one.index} / ${NumOfPackings}`} */}
                              </p>
                            
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
                </div>
              )
              // [...Array(Number(Inputdata.NumOfPackings))].map((_, index) => (
              //   <Space className="qr-space" key={index} direction="vertical" align="center">
              //     <QRCodeSVG value={JSON.stringify(Inputdata)} size={100} />
              //     <p>{index + 1 + ' / ' + Inputdata.NumOfPackings}</p>
              //   </Space>
              // ))
            }
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => handleCloseModel1()}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
  
         <div className="row">
                      <div className="col-sm-2">
                          <div className="form-group">
                              <label className='small m-0'>From</label>
                              <input value={moment(inputData.From).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('From', e.currentTarget.value)} type='date' />
      
                          </div>
                      </div>
                      <div className="col-sm-2">
                          <div className="form-group">
                              <label className='small m-0'>Till</label>
                              <input value={moment(inputData.Till).format('YYYY-MM-DD')} className='form-control form-control-sm' onChange={(e) => handleOnChange('Till', e.currentTarget.value)} type='date' />
      
                          </div>
                      </div>
                 
                      <div className="col-sm-3">  
                      <div className="form-group">
                              <label className='small m-0'>Sticker Printed</label>
                              <AntdSelect
                placeholder={'Print Type'}
                onChange={(value) => {
                
                  console.log(value,"wkhbkfwifiwe")
                  handleOnChange('PrintType',value)
                 
                }}
                value={`${inputData.PrintType == true ?'Yes':inputData.PrintType == false?'No':'All'}` || ""}

                style={{ width: "100%" }}
              >
                {[{Name:'All',value:'All'},{Name:'Yes',value:true},{Name:'No',value:false}].map((one) => {
                  return (
                    <AntdSelect.Option key={one.value} value={one.value}>
                      {`${one.Name}`}
                    </AntdSelect.Option>
                  );
                })}
              </AntdSelect>
      
                          </div>
       
      
            </div>
      
                      <div className="col-sm-1">
                          <button className='btn btn-primary btn-sm mt-4' onClick={() => handleGetData()}>Apply</button>
                      </div>
                
                  </div>
      
      {PdfData && PdfData.length > 0 && EnableAllPdf && (
        <button
          type="button"
          className="btn-sm btn-primary"
          onClick={() => downloadPDFforAll(PdfData)}
        >
          Green Sheet (pdf)
        </button>
      )}
      {RawMaterialData.length < 0 ? (
        "Data Not Available"
      ) : (
        <Table
          columns={columns}
          onSort={handleSort}
          sortColumn={sortColumn}
          data={RawMaterialData}

        />
      )}
    </>
  );
};

export default Kneading_GreenSheet;
